var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.707 12l8.146-8.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L12 11.293 3.853\n  3.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L11.293 12l-8.147 8.146c-.195.196-.195.512 0\n  .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L12 12.707l8.146 8.147c.098.097.226.146.354.146.128 0\n  .256-.049.353-.146.196-.196.196-.512 0-.708L12.707 12z","fill":"currentColor","fillRule":"evenodd"}));
}

Cancel.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Cancel;

Cancel.default = Cancel;
